import { ReactElement } from 'react';
import { useRoutes, Link } from 'react-router-dom';
import {
  CreateScene,
  DeleteScene,
  EntityScene,
  ModelScene,
  IndexScene,
  UpdateScene,
  useEntity,
  AllActivityTypesField,
} from 'components';
import { FactorRateBadge } from 'modules/supplier/factors';
import { Box, TableColumns } from '@ff-it/ui';
import { clampLine } from 'styles/style.css';
import { VendorFactor } from 'modules/supplier/factors/types';
import { VendorFactorForm } from 'modules/supplier/factors/VendorFactorForm';
import permissions from 'modules/supplier/vendor/permissions';
import { TextField } from '@ff-it/form';

const columns: TableColumns<VendorFactor> = [
  {
    content: 'Type',
    key: 'type',
    sortable: true,
    width: 100,
  },
  {
    content: 'Name',
    key: 'name',
    sortable: true,
    render: ({ id, name }: VendorFactor) => <Link to={`${id}`}>{name}</Link>,
  },
  {
    content: 'Description',
    key: 'description',
    render: ({ description }) => <Box className={clampLine}>{description}</Box>,
  },
  {
    content: 'Kind',
    key: 'kind',
    width: 100,
  },
  {
    content: 'Rate',
    key: 'rate',
    width: 100,
    cellProps: {
      textAlign: 'right',
    },
    render: (factor) => <FactorRateBadge factor={factor} />,
  },
];

const initialValues = {
  type: null,
  name: '',
  description: '',
  kind: 'CONSTANT',
  rate: null,
  rates: null,
};

export function VendorFactors(): ReactElement {
  const { endpoint } = useEntity();
  const url = `${endpoint}factors/`;

  const routes = useRoutes([
    {
      index: true,
      element: (
        <IndexScene
          columns={columns}
          filterFields={
            <>
              <TextField name="search" placeholder="Search.." size="sm" />
              <AllActivityTypesField name="type" placeholder="Type" className="ml-1" size="sm" />
            </>
          }
        />
      ),
    },
    {
      path: 'create',
      element: (
        <CreateScene initialValues={initialValues}>
          <VendorFactorForm create />
        </CreateScene>
      ),
    },
    {
      path: ':id/',
      element: <EntityScene />,
      children: [
        {
          index: true,
          element: (
            <UpdateScene>
              <VendorFactorForm create={false} />
            </UpdateScene>
          ),
        },

        {
          path: 'delete',
          element: <DeleteScene />,
        },
      ],
    },
  ]);
  return (
    <ModelScene
      endpoint={url}
      title="Factor"
      pluralTitle="Factors"
      entityTitle={({ name }: VendorFactor) => name}
      permissions={permissions}
    >
      {routes}
    </ModelScene>
  );
}
